import React from "react";
import "./Toolbar.css";
import "./HamburgerButton.js";
import HamburgerButton from "./HamburgerButton.js";

const Toolbar = (props) => {
  return (
    <div dir="rtl" className="toolbar">
      <nav className="toolbar_nav">
        <div className="spacer" />
        <div className="toolbar_logo">
          <text>{props.textPage}</text>
        </div>
        <div className="spacer" />
        <div>
          <HamburgerButton click={props.drawerClickHandler} />
        </div>
        <div className="toolbar_nav_items">
          <ul></ul>
        </div>
      </nav>
    </div>
  );
};

export default Toolbar;
